import { Customer } from '../Client'
import * as api from '../task-detail-api'
import { TransactionType } from '../TransactionType'
import { SourceType } from '../SourceType'
import { DuplicateValue } from './ChangeContactInfo'
import { Relationship } from '../mock'

export interface P4OpsData {
  source: SourceType.PULSE4OPS | SourceType.BANCA_SEA | SourceType.PRUONLINE | SourceType.OUTBOUND | SourceType.INBOUND
  email: string
  email_ind: string
}

export interface DefaultData {
  source: SourceType.BANCA | SourceType.EKIOSK | SourceType.PRUGREAT | SourceType.PULSE | SourceType.ZALO
  email: string
  email_ind?: string | null
}
export interface ChangeEmailInfo {
  tag: TransactionType.CHANGE_CONTACT_INFO_EMAIL
  detail: P4OpsData | DefaultData
  clientName: string
  clientCode: string
  attributesExt?: {
    EMAILS_DUP: Array<DuplicateValue>
  }
}
export const ChangeEmailInfo = (
  detail: api.ChangeEmailInfo,
  client: Customer,
  clientData: Array<{ clientId: string; clientName: string }>
): ChangeEmailInfo => {
  const common: {
    tag: TransactionType.CHANGE_CONTACT_INFO_EMAIL
    clientName: string
    clientCode: string
  } = {
    tag: TransactionType.CHANGE_CONTACT_INFO_EMAIL,
    clientName: client.body.name,
    clientCode: client.body.clientId
  }
  switch (detail.source) {
    case SourceType.PRUONLINE:
    case SourceType.BANCA_SEA:
    case SourceType.OUTBOUND:
    case SourceType.INBOUND:  
    case SourceType.PULSE4OPS:
      return {
        ...common,
        detail: {
          source: detail.source,
          email: detail.payload.body.contactDetails.EMAIL.value ?? '-',
          email_ind: detail.payload.body.contactDetails.EMAIL_IND?.value ?? '-'
        },
        attributesExt: {
          EMAILS_DUP:
            detail.payload.body.attributesExt?.EMAILS_DUP?.filter((e) => !!e.clientId && !!e.relationshipType).map(
              (e) => ({
                clientId: e.clientId ?? '',
                clientName:
                  clientData && clientData.length > 0
                    ? clientData.find((client) => client.clientId === e.clientId)?.clientName ?? ''
                    : '',
                relationship: e.relationshipType
                  ? Relationship.IndicatorRelations.find((relation) => relation.code === e.relationshipType)?.desEn ??
                    ''
                  : '',
                veriRelationship: e.relationshipType
                  ? Relationship.IndicatorRelations.find((relation) => relation.code === e.relationshipType) ?? {
                      code: e.relationshipType,
                      desEn: '',
                      desVi: ''
                    }
                  : { code: '', desEn: '', desVi: '' }
              })
            ) ?? []
        }
      }
    default:
      return {
        ...common,
        detail: {
          source: detail.source,
          email: detail.payload.body.value ?? '-'
        }
      }
  }
}
